import { CardElement } from "@/types/battle"
import { assetUrl } from "@/constants/assetUrl"

export const PLAYER_AVATAR_VARIANT_COUNT = 3 as const

export type PlayerAvatarVariant = 1 | 2 | 3

export const PLAYER_AVATARS_BY_ELEMENT: Record<
  CardElement,
  [string, string, string]
> = {
  FIRE: [
    assetUrl("avatars/fire-1.png"),
    assetUrl("avatars/fire-2.png"),
    assetUrl("avatars/fire-3.png"),
  ],
  WATER: [
    assetUrl("avatars/water-1.png"),
    assetUrl("avatars/water-2.png"),
    assetUrl("avatars/water-3.png"),
  ],
  EARTH: [
    assetUrl("avatars/earth-1.png"),
    assetUrl("avatars/earth-2.png"),
    assetUrl("avatars/earth-3.png"),
  ],
  WIND: [
    assetUrl("avatars/wind-1.png"),
    assetUrl("avatars/wind-2.png"),
    assetUrl("avatars/wind-3.png"),
  ],
  ICE: [
    assetUrl("avatars/ice-1.png"),
    assetUrl("avatars/ice-2.png"),
    assetUrl("avatars/ice-3.png"),
  ],
  LIGHTNING: [
    assetUrl("avatars/lightning-1.png"),
    assetUrl("avatars/lightning-2.png"),
    assetUrl("avatars/lightning-3.png"),
  ],
}

export function normalizeAvatarVariant(value?: number | null): PlayerAvatarVariant {
  const n = Math.floor(Number(value))
  if (n === 2 || n === 3) return n
  return 1
}

export function resolvePlayerAvatarModule(
  element: CardElement,
  variant?: number | null
): string {
  const v = normalizeAvatarVariant(variant)
  return PLAYER_AVATARS_BY_ELEMENT[element][v - 1]
}
